import { Container, Tabs } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"

import { TitleBar } from "../../components/UI/TitleBar"
import ChangePassword from "../../components/UserSettings/ChangePassword"
import UserInformation from "../../components/UserSettings/UserInformation"

const tabsConfig = [
  { title: "Mein Konto", component: UserInformation },
  { title: "Passwort", component: ChangePassword },
]

export const Route = createFileRoute("/_layout/usersettings")({
  component: UserSettings,
})


function UserSettings() {
  const finalTabs = tabsConfig

  return (
    <Container maxW="full">
      <TitleBar title="Benutzereinstellungen" />
      <Tabs.Root variant="outline" defaultValue={finalTabs[0].title}>
        <Tabs.List>
          {finalTabs.map((tab, index) => (
            <Tabs.Trigger key={index} value={tab.title}>
              {tab.title}
            </Tabs.Trigger>
          ))}
        </Tabs.List>

        {finalTabs.map((tab, index) => (
          <Tabs.Content key={index} value={tab.title}>
            <tab.component />
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </Container>
  )
}
